import type { FeatureFlagKey } from "@regrello/feature-flags-api";

export type RegrelloWindowVariableMap = {
  regrelloAllFeatureFlagValues: Record<FeatureFlagKey, boolean>;
  regrelloFeatureFlagWorkspaceUuid: string | null;
};

export function addWindowGlobalVariableTyped<K extends keyof RegrelloWindowVariableMap>(
  name: K,
  value: RegrelloWindowVariableMap[K],
) {
  // biome-ignore lint/suspicious/noExplicitAny: FIXME
  (window as any)[name] = value; // eslint-disable-line @typescript-eslint/no-unsafe-member-access
}

export function getWindowGlobalVariableTyped<K extends keyof RegrelloWindowVariableMap>(
  name: K,
): RegrelloWindowVariableMap[K] | undefined {
  // biome-ignore lint/suspicious/noExplicitAny: FIXME
  return (window as any)[name]; // eslint-disable-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return
}
